module.exports = __webpack_public_path__ + "img/saddle-cloths-5.c8260d21.svg";